import { jsx } from 'react/jsx-runtime';
import { createContext, useRef, useContext, useMemo } from 'react';
import { makeInterceptorContext } from './util.interceptors.js';
import { parseLocationData } from './util.parse-location-data.js';

const NavigationManagerContext = createContext({
  getPath: () => {
    throw new Error(
      "NavigationManagerContext.getPath(): no integration provided"
    );
  },
  subscribe: () => {
    return () => {
    };
  },
  enhanceLink: () => {
    throw new Error(
      "NavigationManagerContext.enhanceLink(): no integration provided"
    );
  },
  push: () => {
    throw new Error(
      "NavigationManagerContext.push(): no integration provided"
    );
  },
  replace: () => {
    throw new Error(
      "NavigationManagerContext.replace(): no integration provided"
    );
  },
  back: () => {
    throw new Error(
      "NavigationManagerContext.back(): no integration provided"
    );
  }
});
const NavigationInterceptorContext = createContext({
  addInterceptor: () => () => {
    throw new Error(
      "NavigationInterceptorContext.addInterceptor(): not implemented!"
    );
  },
  runInterceptors: () => Promise.resolve({
    isCancelled: () => false,
    cancel: () => {
      throw new Error(
        "NavigationInterceptorContext.runInterceptors(): not implemented!"
      );
    }
  })
});
function NavigationManagerProvider(props) {
  const interceptorRef = useRef(makeInterceptorContext());
  return /* @__PURE__ */ jsx(NavigationManagerContext.Provider, { value: props.manager, children: /* @__PURE__ */ jsx(NavigationInterceptorContext.Provider, { value: interceptorRef.current, children: props.children }) });
}
function useNavigationManager() {
  const context = useContext(NavigationManagerContext);
  const interceptorContext = useContext(NavigationInterceptorContext);
  return useMemo(() => {
    const { getPath, enhanceLink, push, replace, back, ...manager } = context;
    const { runInterceptors, ...interceptorManager } = interceptorContext;
    return {
      ...manager,
      ...interceptorManager,
      async push(path) {
        const cancelToken = await runInterceptors(path);
        if (!cancelToken.isCancelled()) {
          push(path);
        }
      },
      async replace(path) {
        const cancelToken = await runInterceptors(path);
        if (!cancelToken.isCancelled()) {
          replace(path);
        }
      },
      async back() {
        back();
      },
      getLocation() {
        return parseLocationData(getPath());
      }
    };
  }, [context, interceptorContext]);
}

export { NavigationInterceptorContext, NavigationManagerContext, NavigationManagerProvider, useNavigationManager };
//# sourceMappingURL=hook.manager.js.map
